import {Service} from "vue-typedi";
import {storesApiClient} from "@/configuration/api-client";
import {Drive} from "@/model/Drive";

@Service()
export class DriveService {
    public static readonly DRIVES_ENDPOINT: string = '/drives';
    public static readonly DRIVES_BY_STORE_ENDPOINT: string = '/store';

    public getDrivesByStoreId(storeId: string): Promise<Drive[]> {
        return storesApiClient.get<Drive[]>(DriveService.DRIVES_ENDPOINT + DriveService.DRIVES_BY_STORE_ENDPOINT + '/' + storeId)
            .then(response => Promise.resolve(response.data));
    }

}